import { useEffect, useRef, useState } from 'react';
import crosssimgiocn from "../../Images/crosssimgiocn.png"
import Neoologoasjji from "../../Images/Neoologoasjji.png";
import postbanneimmhg from "../../Images/postbanneimmhg.png";
import prodlikeicon from "../../Images/prodlikeicon.png";
import prodlikedicon from "../../Images/liked.png";
import commenytstproodiuificon from "../../Images/commenytstproodiuificon.png";
import msgiocn from "../../Images/msgiocn.png";
import Ownpostpagemodal from '../../Modal/Ownpostpagemodal';
import HttpClient from '../../utils/HttpClient';
import { formatDateAgo } from '../../utils/Helper';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllBusinessPosts, LoadBusinessPostsInBackground } from '../../Redux/Slice/BusinessPostSlice';
import ItemLoader from '../../Component/ItemLoader';
import PostEnqueyModalNew from '../../Modal/PostEnqueyModalNew';
import { getSingleUserProfile, ShareModalonOff } from '../../Redux/Slice/PostSlice';
import { useLocation, useNavigate, useParams, Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import ProfileShare from '../../Modal/ProfileShare';
import PostCommentsNew from "./PostCommentsNew";

const Allpostpage = () => {
    const { status, AllBusinessPosts } = useSelector((state) => state.post);
    const { ShareModalOpenClose, UserProfileID } = useSelector((state) => state.app);
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const params = useParams()

    const [othersPostUpdates, setOthersPostUpdates] = useState(
        AllBusinessPosts.filter(item => item.userData._id !== UserProfileID?._id)
    )

    useEffect(() => {
        const a = AllBusinessPosts.filter(item => item.userData._id !== UserProfileID?._id)
        setOthersPostUpdates(a)
    }, [AllBusinessPosts])

    const [loadmtersdiumodal, setLoadmtersdiumodal] = useState(false);
    const [handleownpostmodal, sethandleownpostmodal] = useState(false)
    const loadmoresfgbtbnbclokj = () => {
        setLoadmtersdiumodal(!loadmtersdiumodal)
    }
    const [threedpotsspclmodal, setThreedpotsspclmodal] = useState(true);
    const [ownpostcommetclickmodal, setownpostcommetclickmodal] = useState(false)

    const [menuPostID, setMenuPostID] = useState()
    const threedotssettingclcil = (e, id) => {
        e.preventDefault()
        setMenuPostID(id)
        threedpotsspclmodal ? setThreedpotsspclmodal(true) : setThreedpotsspclmodal(!threedpotsspclmodal)
    }

    const [commentPostID, setCommentPostID] = useState()
    const ownposcommentclcik = (e, id) => {
        e.preventDefault()
        setCommentPostID(id)
        ownpostcommetclickmodal ? setownpostcommetclickmodal(true) : setownpostcommetclickmodal(!ownpostcommetclickmodal)
        // setownpostcommetclickmodal(true)
        // setThreedpotsspclmodal(!threedpotsspclmodal)
    }

    const [queryPostID, setQueryPostID] = useState()
    const [sendQueryModal, setSendQueryModal] = useState(false)

    const handleQuery = (e, id, userId, item) => {
        e.preventDefault()
        setQueryPostID(id)
        setSelectedPostData(item)
        UserProfileID?._id !== userId && setSendQueryModal(!sendQueryModal)
    }

    const [selectedPostData, setSelectedPostData] = useState()
    const handleopwmnpostmodal = (e, item) => {
        e.preventDefault()
        setSelectedPostData(item)
        sethandleownpostmodal(!handleownpostmodal)
    }

    //Display Posts
    const [allData, setAllData] = useState([])

    const [visibleItems, setVisibleItems] = useState([]);
    const [itemsToShow, setItemsToShow] = useState(3);
    const loadMoreItems = 1;

    const handleLoadMore = () => {
        // Load more items by increasing the itemsToShow count
        setItemsToShow((prev) => prev + loadMoreItems);
    };

    useEffect(() => {
        UserProfileID ? dispatch(fetchAllBusinessPosts()) : navigate('/user-login')
    }, [])

    useEffect(() => {
        setVisibleItems(
            [...othersPostUpdates]
                // .filter(item => item.userData._id !== UserProfileID._id)
                .sort((a, b) => (b._id === params?.id ? 1 : 0) - (a._id === params?.id ? 1 : 0))
                .slice(0, itemsToShow)
        );
    }, [itemsToShow, othersPostUpdates]);

    const handlePostLike = async (e, data) => {
        e.preventDefault()
        if (UserProfileID?._id === data?.profileId) return
        try {
            const response = await HttpClient.requestData(
                "business-post-like",
                "POST",
                { postId: data?._id }
            );
            if (response.status) {
                dispatch(LoadBusinessPostsInBackground())
            } else {
                console.error("Error in Like/Dislike");
            }
        } catch (error) {
            console.error("Error submitting Like/Dislike:", error);
        } finally {
            dispatch(LoadBusinessPostsInBackground())
        }
    }

    const gotoBusinessListing = (e, user) => {
        e.preventDefault()
        dispatch(getSingleUserProfile(user?._id))
        const link = user?.companySlug || user?.companyName?.toLowerCase().replace(/\s+/g, "_");
        navigate(`/businesspage/${link}`)
    }

    const hidePost = async (e, postId) => {
        e.preventDefault()
        try {
            const response = await HttpClient.requestData(
                `hide-others-post/${postId}`,
                "PUT",
            );
            if (response.status) {
                toast.success("Post removed successfully.")
            } else {
                console.error("Error in Like/Dislike");
            }
        } catch (error) {
            console.error("Error submitting Like/Dislike:", error);
        } finally {
            dispatch(LoadBusinessPostsInBackground())
        }

    }

    const location = useLocation();
    const copyPostLink = (e, postId) => {
        e.preventDefault()
        const postUrl = `${window.location.origin}/ownpostpage/${postId}`;
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(postUrl).then(() => {
                toast.success("Copied Successfully");
                setThreedpotsspclmodal(false)
            });
        } else {
            toast.error("Clipboard not supported in this browser.")
        }
    }
    const [sharemodal, setSharemodal] = useState(false);
    const [postLink, setPostLink] = useState("")
    const shareClick = (e, postId) => {
        e.preventDefault()
        const postUrl = `${window.location.origin}/ownpostpage/${postId}`;
        setPostLink(postUrl)
        setSharemodal(!sharemodal);
        dispatch(ShareModalonOff(true));
    };

    const divRef = useRef(null);
    const handleClickOutside = (e) => {
        if (divRef.current && !divRef.current.contains(e.target)) {
            setThreedpotsspclmodal(false)
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const navigatePostView = (e, item) => {
        e.preventDefault()
        navigate(`/ownpostpage/${item._id}`)
    }

    return (
        <>
            {
                status === "loading" ? (
                    <>
                        <ItemLoader />
                    </>
                ) : (
                    <>
                        <div className='allpostowndmaimndivmain'>
                            {
                                visibleItems.map((post, index) => {

                                    return (
                                        <>
                                            {/* Single Post Start */}
                                            <div className='allpostowndmaimndiv' key={`allpost-${index}`}
                                            // onClick={(e)=>handleopwmnpostmodal(e,post)}
                                            >
                                                <div className='allpostowndmaimndivallelemnt'>
                                                    <div className='allpostimagedesuigfnatinob'
                                                        onClick={(e) => gotoBusinessListing(e, post?.userData)}
                                                        style={{ cursor: "pointer" }}
                                                    >
                                                        <div className='allposttslodjjimg'>
                                                            <Link
                                                                to={post?.userData?.companySlug ? `/businesspage/${post?.userData?.companySlug}` : `#`}
                                                                className="profileLink">
                                                                <img src={post?.userData?.businessProfilePic || Neoologoasjji} alt='Profile Image' />
                                                            </Link>
                                                        </div>
                                                        <div className=''>
                                                            <h4 className='neeporoalposttsheadr'>{post?.userData?.companyName}</h4>
                                                            {/* <p className='cmskshhstdiifgysyttxtpop'><span>Computer </span> |  <sapn> hardware </sapn> | <span>Digital marketing </span></p> */}
                                                            {/* <p className='cmskshhstdiifgysyttxtpop'>{post?.userData?.businessProductCat?.join(" | ")}</p> */}
                                                            <p className='cmskshhstdiifgysyttxtpop'>{post?.userData?.companytypename}</p>
                                                        </div>
                                                    </div>
                                                    <div className='crosasddoproidikdsjbhidivflx'>
                                                        <div className='threediostyiicpnggsuc'>
                                                            <div className='threediostyiicpn ' onClick={(e) => threedotssettingclcil(e, post?._id)}>
                                                                <i className="fa-solid fa-ellipsis" style={{ cursor: "pointer" }}></i>
                                                            </div>
                                                            {(threedpotsspclmodal && menuPostID === post?._id) &&
                                                                <div className='threedotssettingdiv'
                                                                    ref={divRef}
                                                                >
                                                                    <ul className="userMenu">
                                                                        <li>
                                                                            <a
                                                                                href="javascript:"
                                                                                onClick={(e) => copyPostLink(e, post?._id)}
                                                                            >
                                                                                <i className="fa-solid fa-link mr-2"></i>
                                                                                Copy post link
                                                                            </a>
                                                                        </li>
                                                                        <li>
                                                                            <a
                                                                                href="javascript:"
                                                                                onClick={(e) => shareClick(e, post?._id)}
                                                                            >

                                                                                <i className="fa-solid fa-share-nodes  mr-2"></i>
                                                                                Share post link
                                                                            </a>
                                                                        </li>
                                                                        <li>
                                                                            <a href="javascript:"
                                                                                onClick={(e) => hidePost(e, post?._id)}
                                                                            >
                                                                                <i className="fa-solid fa-trash mr-2"></i>
                                                                                Delete
                                                                            </a>
                                                                        </li>
                                                                    </ul>
                                                                </div>}
                                                        </div>
                                                        {
                                                            post?.userData?._id === UserProfileID?._id &&
                                                            <div className='crossidovpostimgdiv'
                                                                onClick={(e) => hidePost(e, post?._id)}
                                                            >
                                                                <img src={crosssimgiocn} alt='...' />
                                                                {/* {post?._id} */}
                                                            </div>
                                                        }



                                                    </div>
                                                </div>
                                                <div className='postbannettimhdivflxmakflx'>
                                                    <div className='postbanneimmhgdivjakhjimh mt-4'
                                                        // onClick={(e) => handleopwmnpostmodal(e, post)}
                                                        onClick={(e) => navigatePostView(e, post)}
                                                    >
                                                        <img src={post?.file || postbanneimmhg} alt={post?.subject} style={{ borderRadius: "12px", cursor: "pointer" }} />
                                                    </div>
                                                    <div className='poosttalouindtdettstctpopdoiv'
                                                        // onClick={(e) => handleopwmnpostmodal(e, post)}
                                                        onClick={(e) => navigatePostView(e, post)}

                                                        style={{
                                                            cursor: "pointer"
                                                        }}
                                                    >
                                                        <p style={{ font: "500 17px / 20px Roboto", marginBottom: "3px" }}>{post?.subject}</p>
                                                        <p className='postimagedesrcptoioponttxp'>
                                                            {post?.description.length > 175 ? `${post.description.slice(0, 175)}...` : post?.description}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className=''>
                                                    <p className='htrrstrtdttgsgbtxttppgh'>{formatDateAgo(post?.createdOn)}</p>
                                                </div>
                                                <div className="allpostlikecommetsendenqeryudiv">
                                                    <div className="prodctlikecmntenquerypagediv">
                                                        <div className="produucvtsdlikeinmncomnfdivvhjjd"
                                                            onClick={(e) => { handlePostLike(e, post) }}
                                                        >
                                                            <div className="produucvtsdlikeinmncomnf">
                                                                <img
                                                                    src={post?.PostLikeData.some(item => item.likedBy === UserProfileID?._id) ? prodlikedicon : prodlikeicon}
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <p className="likkskjsbtcomnbvtyoipuxtt">
                                                                {/* Like <span>{activePostId === post._id ? likeCounter : post?.PostLikeCount}</span> */}
                                                                Like <span>{post?.PostLikeCount}</span>
                                                            </p>
                                                        </div>

                                                        <div className="produucvtsdlikeinmncomnfdivvhjjd" onClick={(e) => ownposcommentclcik(e, post?._id)}>
                                                            <div className="produucvtsdlikeinmncomnf">
                                                                <img
                                                                    src={commenytstproodiuificon}
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <p className="likkskjsbtcomnbvtyoipuxtt">Comment <span>{post?.PostCommentData?.length}</span></p>
                                                        </div>

                                                        {sendQueryModal &&
                                                            <><PostEnqueyModalNew closemodal={setSendQueryModal} post={queryPostID} postData={selectedPostData} /></>
                                                        }


                                                        <div className="produucvtsdlikeinmncomnfdivvhjjd"
                                                            onClick={(e) => handleQuery(e, post?._id, post?.userData?._id, post)}
                                                        >
                                                            <div className="produucvtsdlikeinmncomnf">
                                                                <img
                                                                    src={msgiocn}
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <p className="likkskjsbtcomnbvtyoipuxtt">Send Equiry</p>
                                                        </div>
                                                    </div>
                                                    {ownpostcommetclickmodal && commentPostID === post?._id &&
                                                        <PostCommentsNew data={post?.PostCommentData} postProfileId={post?.profileId} postId={post?._id} />
                                                    }
                                                </div>
                                            </div>
                                            {/* //Single Post End */}
                                        </>
                                    )
                                })
                            }


                            {loadmtersdiumodal &&
                                <>
                                </>
                            }

                            {
                                othersPostUpdates?.length > visibleItems?.length &&
                                <div className='lodmrebtnmainndivmaindib'>
                                    <button className='lodmrebtnmainndiv'
                                        // onClick={loadmoresfgbtbnbclokj}
                                        onClick={handleLoadMore}
                                    >
                                        Load More
                                    </button>
                                </div>
                            }

                            {ShareModalOpenClose && (
                                <ProfileShare
                                    whatsApp={postLink}
                                    linkedInLink={postLink}
                                    facebookLink={postLink}
                                    userLink={postLink}
                                    instaLink={postLink}
                                    emailId={postLink}
                                // closeModal={setSharemodal}
                                />
                            )}
                        </div>
                        {handleownpostmodal && <Ownpostpagemodal closemodal={sethandleownpostmodal} data={selectedPostData} />}
                    </>
                )
            }

        </>
    )
}

export default Allpostpage
